<template>
    <div>
        <div class="btn-group btn-block" role="group" aria-label="Basic example">
            <button @click="currentTab = '12'" :class="{ active : currentTab === '12' }" class="btn font-weight-bold btn-outline-info">12 годин</button>
            <button @click="currentTab = '24'" :class="{ active : currentTab === '24' }" class="btn font-weight-bold btn-outline-info">24 години</button>
            <button @click="currentTab = '48'" :class="{ active : currentTab === '48' }" class="btn font-weight-bold btn-outline-info">48 годин</button>
            <button @click="currentTab = 'week'" :class="{ active : currentTab === 'week' }" class="btn font-weight-bold btn-outline-info">7 днів</button>
            <button @click="currentTab = 'month'" :class="{ active : currentTab === 'month' }" class="btn font-weight-bold btn-outline-info">30 днів</button>
        </div>
        <EmptyModal :open="modal">
            <date-picker v-model="date" :config="options"></date-picker>
        </EmptyModal>
    </div>

</template>

<script>

import EventBus from "./EventBus";
import EmptyModal from "./EmptyModal";
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from "moment-mini"

export default {
    name: "DatePicker",
    components: {
        datePicker,
        EmptyModal
    },
    data() {
        return {
            modal: false,
            currentTab: "12",
            date: new Date(),
            options: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                locale: 'uk',
                minDate: moment().subtract(30, "days"),
                maxDate: moment()
            }
        }
    },
    methods: {
        openModal() {
            this.modal = true;
        }
    },
    watch: {
        currentTab(val) {
            this.$emit("change", val);

            if (val === '12') {
                EventBus.$emit("DP_CHANGE", {
                    start: moment().format("YYYY-MM-DD"),
                    stop: moment().subtract(12, 'hours').format("YYYY-MM-DD")
                });
            }

            if (val === '24') {
                EventBus.$emit("DP_CHANGE", {
                    start: moment().format("YYYY-MM-DD"),
                    stop: moment().subtract(24, 'hours').format("YYYY-MM-DD")
                });
            }

            if (val === '48') {
                EventBus.$emit("DP_CHANGE", {
                    start: moment().format("YYYY-MM-DD"),
                    stop: moment().subtract(48, 'hours').format("YYYY-MM-DD")
                });
            }
            if (val === 'week') {
                EventBus.$emit("DP_CHANGE", {
                    start: moment().format("YYYY-MM-DD"),
                    stop: moment().subtract(7, 'days').format("YYYY-MM-DD")
                });
            }
            if (val === 'month') {
                EventBus.$emit("DP_CHANGE", {
                    start: moment().format("YYYY-MM-DD"),
                    stop: moment().subtract(30, 'days').format("YYYY-MM-DD")
                });
            }
        }
    }
}
</script>

<style scoped>

</style>